'use strict';

import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import Item from './Item';

var Presentation = function (_Item) {
    _inherits(Presentation, _Item);

    function Presentation(data) {
        _classCallCheck(this, Presentation);

        var _this = _possibleConstructorReturn(this, (Presentation.__proto__ || _Object$getPrototypeOf(Presentation)).call(this, data));

        if (!_this.props) {
            return _possibleConstructorReturn(_this);
        }

        if (_this.props.PresenterInfo) {
            _this.props.PresenterInfo = JSON.parse(_this.props.PresenterInfo);
        }

        if (_this.props.PresenterProfiles) {
            _this.props.PresenterProfiles = JSON.parse(_this.props.PresenterProfiles);
        }

        if (_this.props.Resources) {
            _this.props.Resources = JSON.parse(_this.props.Resources);
        }

        if (_this.props.SurveyInstances) {
            _this.props.SurveyInstances = JSON.parse(_this.props.SurveyInstances);
        }

        if (_this.props.Surveys) {
            _this.props.Surveys = JSON.parse(_this.props.Surveys);

            for (var i = 0; i < _this.props.Surveys.length; i++) {
                _this.props.Surveys[i] = JSON.parse(_this.props.Surveys[i]);
            }
        }
        return _this;
    }

    // Added data


    return Presentation;
}(Item);

export default Presentation;


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/Items/Presentation.js
// module id = 498
// module chunks = 0